// import React, { useEffect, useState } from "react";
// import { Box, Button, IconButton, useTheme } from "@mui/material";
// import { useGetWeightCalcListQuery } from "../../state/api";
// import Header from "../../components/Header";
// import { DataGrid } from "@mui/x-data-grid";
// import CustomColumnMenu from "../../components/DataGridCustomColumnMenu";
// import AddCircleIcon from "@mui/icons-material/AddCircle";
// import DeleteIcon from "@mui/icons-material/Delete";
// import EditIcon from "@mui/icons-material/Edit";
// import { useNavigate } from "react-router-dom";
// import { format } from "date-fns";
// import Switch from "@mui/material/Switch";
// import { deleteWeightCalcAction } from "../../redux/actions/weightCalcAction";
// import { useDispatch } from "react-redux";
// import Swal from "sweetalert2";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { usePostUpdateStatusMutation } from "../../state/api";

// const WeightCalc = () => {
//   const theme = useTheme();
//   const { data, isLoading } = useGetWeightCalcListQuery();
//   const [rowData, setRowData] = useState([]);
//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   useEffect(() => {
//     if (data && data.success) {
//       const formattedWeightCalcs = data.weightCalcs.map((weightCalc) => ({
//         _id: weightCalc._id,
//         calctype: weightCalc.calctype,
//         factor: weightCalc.factor,
//         weight: weightCalc.weight,
//       }));
//       setRowData(formattedWeightCalcs);
//     }
//   }, [data]);

//   const handleEdit = (id) => {
//     navigate(`/weightCalc/edit/${id}`);
//   };

//   const handleDelete = async (_id) => {
//     try {
//       const success = await dispatch(deleteWeightCalcAction(_id));
//       if (success) {
//         toast.success("WeightCalc deleted successfully");
//         setRowData((prevData) => prevData.filter(row => row._id !== _id));
//       } else {
//         toast.error("Failed to delete weightCalc");
//       }
//     } catch (error) {
//       console.error("Error deleting weightCalc:", error);
//     }
//   };

//   const removeWeightCalc = (_id) => {
//     Swal.fire({
//       title: "Confirm Removal",
//       text: "Are you sure you want to remove this?",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#3085d6",
//       cancelButtonColor: "#d33",
//       confirmButtonText: "Yes, remove it!",
//     }).then((result) => {
//       if (result.isConfirmed) {
//         handleDelete(_id);
//       }
//     });
//   };

//   const [updateStatus] = usePostUpdateStatusMutation();

//   const handleStatus = async (Id, isActive) => {
//     const tag = "WeightCalc";
//     try {
//       const response = await updateStatus({ Id, tag, isActive });
//       if (response.data.success) {
//         setRowData((prevData) =>
//           prevData.map((row) =>
//             row._id === Id ? { ...row, isActive: !isActive } : row
//           )
//         );
//         toast.success("Status updated successfully");
//       } else {
//         toast.error("Failed to update status");
//       }
//     } catch (error) {
//       console.error("Error updating status:", error);
//       toast.error("Failed to update status");
//     }
//   };

//   const columns = [
//     {
//       field: "calctype",
//       headerName: "Calc Type",
//       flex: 1,
//     },
//     {
//       field: "factor",
//       headerName: "Factor",
//       flex: 1,
//     },
//     {
//       field: "weight",
//       headerName: "Weight",
//       flex: 1,
//     },
//     {
//       field: "actions",
//       headerName: "Actions",
//       flex: 1,
//       renderCell: (params) => (
//         <div>
//           <IconButton
//             color="info"
//             onClick={() => handleEdit(params.row._id)}
//           >
//             <EditIcon size="large" />
//           </IconButton>
//           <IconButton
//             color="secondary"
//             onClick={() => removeWeightCalc(params.row._id)}
//           >
//             <DeleteIcon size="small" sx={{ color: "red" }} />
//           </IconButton>
//         </div>
//       ),
//     },
//   ];

//   return (
//     <Box m="1.5rem 2.5rem">
//       <ToastContainer />
//       <Box
//         display="flex"
//         flexDirection="column"
//         alignItems="center"
//         justifyContent="center"
//       >
//         <Header title="WEIGHTCALC MANAGEMENT" />
//       </Box>
//       <div className="align-right">
//         <Button
//           variant="contained"
//           endIcon={<AddCircleIcon />}
//           onClick={() => navigate("/weightCalc/create")}
//         >
//           Add WeightCalc
//         </Button>
//       </div>

//       <Box
//         mt="40px"
//         height="75vh"
//         sx={{
//           "& .MuiDataGrid-root": {
//             border: "none",
//           },
//           "& .MuiDataGrid-cell": {
//             borderBottom: "none",
//           },
//           "& .MuiDataGrid-columnHeaders": {
//             backgroundColor: theme.palette.background.alt,
//             color: theme.palette.secondary[100],
//             borderBottom: "none",
//           },
//           "& .MuiDataGrid-virtualScroller": {
//             backgroundColor: theme.palette.primary.success,
//           },
//           "& .MuiDataGrid-footerContainer": {
//             backgroundColor: theme.palette.background.alt,
//             color: theme.palette.secondary[100],
//             borderTop: "none",
//           },
//           "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
//             color: `${theme.palette.secondary[200]} !important`,
//           },
//         }}
//       >
//         <DataGrid
//           loading={isLoading || !data}
//           getRowId={(row) => row._id}
//           rows={rowData || []}
//           columns={columns}
//           components={{
//             ColumnMenu: CustomColumnMenu,
//           }}
//         />
//       </Box>
//     </Box>
//   );
// };

// export default WeightCalc;


import React, { useEffect, useState } from "react";
import { Box, Button, IconButton, useTheme } from "@mui/material";
import { useGetWeightCalcListQuery } from "../../state/api";
import Header from "../../components/Header";
import { DataGrid } from "@mui/x-data-grid";
import CustomColumnMenu from "../../components/DataGridCustomColumnMenu";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { deleteWeightCalcAction } from "../../redux/actions/weightCalcAction";
import Swal from "sweetalert2";
import { useDispatch } from "react-redux";

const WeightCalc = () => {
  const theme = useTheme();
  const { data, isLoading } = useGetWeightCalcListQuery();
  const [rowData, setRowData] = useState([]);
  const [pageSize, setPageSize] = useState(20);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (data && data.success) {
      const formattedWeightCalcs = data.weightCalcs.map((weightCalc) => ({
        _id: weightCalc._id,
        calctype: weightCalc.calctype,
        factor: weightCalc.factor,
        weight: weightCalc.weight,
      }));
      setRowData(formattedWeightCalcs);
    }
  }, [data]);

  const handleEdit = (id) => {
    navigate(`/weightCalc/edit/${id}`);
  };

  const handleDelete = async (_id) => {
    try {
      const success = await dispatch(deleteWeightCalcAction(_id));
      if (success) {
        toast.success("WeightCalc deleted successfully");
        setRowData((prevData) => prevData.filter(row => row._id !== _id));
      } else {
        toast.error("Failed to delete weightCalc");
      }
    } catch (error) {
      console.error("Error deleting weightCalc:", error);
    }
  };

  const removeWeightCalc = (_id) => {
    Swal.fire({
      title: "Confirm Removal",
      text: "Are you sure you want to remove this?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, remove it!",
    }).then((result) => {
      if (result.isConfirmed) {
        handleDelete(_id);
      }
    });
  };

  const columns = [
    {
      field: "calctype",
      headerName: "Calc Type",
      flex: 1,
    },
    {
      field: "factor",
      headerName: "Factor",
      flex: 1,
    },
    {
      field: "weight",
      headerName: "Weight",
      flex: 1,
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 1,
      renderCell: (params) => (
        <div>
          <IconButton
            color="info"
            onClick={() => handleEdit(params.row._id)}
          >
            <EditIcon size="large" />
          </IconButton>
          <IconButton
            color="secondary"
            onClick={() => removeWeightCalc(params.row._id)}
          >
            <DeleteIcon size="small" sx={{ color: "red" }} />
          </IconButton>
        </div>
      ),
    },
  ];

  return (
    <Box m="1.5rem 2.5rem">
      <ToastContainer />
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        flexWrap="wrap"
        gap="1rem"
      >
        <Header title="WEIGHTCALC MANAGEMENT" />
        <Button
          variant="contained"
          endIcon={<AddCircleIcon />}
          onClick={() => navigate("/weightCalc/create")}
        >
          Add WeightCalc
        </Button>
      </Box>

      <Box
        mt="40px"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: theme.palette.primary.success,
          },
          "& .MuiDataGrid-footerContainer": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderTop: "none",
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${theme.palette.secondary[200]} !important`,
          },
        }}
      >
        <DataGrid
          loading={isLoading || !data}
          getRowId={(row) => row._id}
          rows={rowData || []}
          columns={columns}
          pagination
          pageSize={pageSize}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          rowsPerPageOptions={[10, 20, 50, 100]}
          components={{
            ColumnMenu: CustomColumnMenu,
          }}
        />
      </Box>
    </Box>
  );
};

export default WeightCalc;
